import { useSyncExternalStore } from "react"

let state = { open: false, initialBilling: null, pendingAction: null }
const listeners = new Set()

function emit() {
  listeners.forEach((l) => l())
}

export const paywallTrigger = {
  get() {
    return state
  },
  subscribe(listener) {
    listeners.add(listener)
    return () => listeners.delete(listener)
  },
  open(arg) {
    let pendingAction = null
    let initialBilling = null
    if (typeof arg === "function") {
      pendingAction = arg
    } else if (arg && typeof arg === "object") {
      pendingAction = arg.pendingAction ?? null
      initialBilling = arg.initialBilling ?? null
    }
    state = { open: true, initialBilling, pendingAction }
    emit()
  },
  close() {
    state = { open: false, initialBilling: null, pendingAction: null }
    emit()
  },
  completeAndResume() {
    const pending = state.pendingAction
    state = { open: false, initialBilling: null, pendingAction: null }
    emit()
    if (pending) pending()
  },
}

export function usePaywall() {
  return useSyncExternalStore(paywallTrigger.subscribe, paywallTrigger.get, paywallTrigger.get)
}
